module.exports = __webpack_public_path__ + "img/face67.781907d6.gif";